import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-academic-calender',
  templateUrl: './academic-calender.component.html',
  styleUrls: ['./academic-calender.component.scss']
})
export class AcademicCalenderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
